export const API_TOOLS_URL: string = process.env.NX_API_TOOLS || '';
export const PICSART_API_BASE_URL = process.env.NX_PICSART_API || '';
export const AUTH_REDIRECT_URL: string = process.env.NX_AUTH_REDIRECT || '';
export const AUTH_CLIENT_ID = process.env.NX_AUTH_CLIENT_ID || '';
export const AUTH_POPUP_BASE = process.env.NX_AUTH_POPUP_BASE || '';
export const AUTH_ACCEPTED_ORIGIN = process.env.NX_AUTH_ACCEPTED_ORIGIN || '';

// Google Add Manager
export const GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_WEB = 'div-gpt-ad-1716301271102-0';
export const GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB = 'div-gpt-ad-1716301109334-0';
export const GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE = 'div-gpt-ad-1717012760915-0';
export const GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE_2 = 'div-gpt-ad-1717012760915-1';
export const GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE = 'div-gpt-ad-1717012639161-0';
export const GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE_2 = 'div-gpt-ad-1717012639161-1';
